// Schedule I column definitions - EXACTLY matching the template
// Total: 59 columns from A to BG

export const SCHEDULE_I_COLUMNS = Object.freeze([
  // Contract Information (Columns A-H)
  { label: 'Start Year', key: 'start_year', category: 'info', col: 'A' },
  { label: 'Internal Contract Number', key: 'internal_contract_number', category: 'info', col: 'B' },
  { label: 'Level 1 Project Number', key: 'level_1_project_number', category: 'info', col: 'C' },
  { label: 'Prime Contract Number', key: 'prime_contract_number', category: 'info', col: 'D' },
  { label: 'Sub Contract Number', key: 'sub_contract_number', category: 'info', col: 'E' },
  { label: 'Contract Type', key: 'contract_type', category: 'info', col: 'F' },
  { label: 'Prime or Sub', key: 'prime_or_sub', category: 'info', col: 'G' },
  { label: 'DoD or Non DoD', key: 'dod_or_non_dod', category: 'info', col: 'H' },
  
  // Cost Totals (Columns I-L)
  { label: 'Settled Costs', key: 'settled_costs', category: 'costs', col: 'I' },
  { label: 'Prior Year Unsettled Costs', key: 'prior_year_unsettled_costs', category: 'costs', col: 'J' },
  { label: 'Current Year End Costs Claimed', key: 'current_year_end_costs_claimed', category: 'costs', col: 'K' },
  { label: 'Total Cumulative Settled or Claimed', key: 'total_cumulative_settled_or_claimed', category: 'costs', col: 'L' },
  
  // Less Div #2 Unbillable (Columns M-R)
  { label: 'Less Div #2 Company Unbillable Labor', key: 'less_div2_company_unbillable_labor', category: 'unbillable', col: 'M' },
  { label: 'Less Div #2 Company Unbillable Fringe', key: 'less_div2_company_unbillable_fringe', category: 'unbillable', col: 'N' },
  { label: 'Less Div #2 Company Unbillable Overhead', key: 'less_div2_company_unbillable_overhead', category: 'unbillable', col: 'O' },
  { label: 'Less Div #2 Client Unbillable Labor', key: 'less_div2_client_unbillable_labor', category: 'unbillable', col: 'P' },
  { label: 'Less Div #2 Client Unbillable Fringe', key: 'less_div2_client_unbillable_fringe', category: 'unbillable', col: 'Q' },
  { label: 'Less Div #2 Client Unbillable Overhead', key: 'less_div2_client_unbillable_overhead', category: 'unbillable', col: 'R' },
  
  // Less Div #4 Unbillable (Columns S-X)
  { label: 'Less Div #4 Company Unbillable Labor', key: 'less_div4_company_unbillable_labor', category: 'unbillable', col: 'S' },
  { label: 'Less Div #4 Company Unbillable Fringe', key: 'less_div4_company_unbillable_fringe', category: 'unbillable', col: 'T' },
  { label: 'Less Div #4 Company Unbillable Overhead', key: 'less_div4_company_unbillable_overhead', category: 'unbillable', col: 'U' },
  { label: 'Less Div #4 Client Unbillable Labor', key: 'less_div4_client_unbillable_labor', category: 'unbillable', col: 'V' },
  { label: 'Less Div #4 Client Unbillable Fringe', key: 'less_div4_client_unbillable_fringe', category: 'unbillable', col: 'W' },
  { label: 'Less Div #4 Client Unbillable Overhead', key: 'less_div4_client_unbillable_overhead', category: 'unbillable', col: 'X' },
  
  // Less Div #6 Unbillable (Columns Y-AD)
  { label: 'Less Div #6 Company Unbillable Labor', key: 'less_div6_company_unbillable_labor', category: 'unbillable', col: 'Y' },
  { label: 'Less Div #6 Company Unbillable Fringe', key: 'less_div6_company_unbillable_fringe', category: 'unbillable', col: 'Z' },
  { label: 'Less Div #6 Company Unbillable Overhead', key: 'less_div6_company_unbillable_overhead', category: 'unbillable', col: 'AA' },
  { label: 'Less Div #6 Client Unbillable Labor', key: 'less_div6_client_unbillable_labor', category: 'unbillable', col: 'AB' },
  { label: 'Less Div #6 Client Unbillable Fringe', key: 'less_div6_client_unbillable_fringe', category: 'unbillable', col: 'AC' },
  { label: 'Less Div #6 Client Unbillable Overhead', key: 'less_div6_client_unbillable_overhead', category: 'unbillable', col: 'AD' },
  
  // Less Div #8 Unbillable (Columns AE-AG) - Company only
  { label: 'Less Div #8 Company Unbillable Labor', key: 'less_div8_company_unbillable_labor', category: 'unbillable', col: 'AE' },
  { label: 'Less Div #8 Company Unbillable Fringe', key: 'less_div8_company_unbillable_fringe', category: 'unbillable', col: 'AF' },
  { label: 'Less Div #8 Company Unbillable Overhead', key: 'less_div8_company_unbillable_overhead', category: 'unbillable', col: 'AG' },
  
  // Less Div #10 Unbillable (Columns AH-AM)
  { label: 'Less Div #10 Company Unbillable Labor', key: 'less_div10_company_unbillable_labor', category: 'unbillable', col: 'AH' },
  { label: 'Less Div #10 Company Unbillable Fringe', key: 'less_div10_company_unbillable_fringe', category: 'unbillable', col: 'AI' },
  { label: 'Less Div #10 Company Unbillable Overhead', key: 'less_div10_company_unbillable_overhead', category: 'unbillable', col: 'AJ' },
  { label: 'Less Div #10 Client Unbillable Labor', key: 'less_div10_client_unbillable_labor', category: 'unbillable', col: 'AK' },
  { label: 'Less Div #10 Client Unbillable Fringe', key: 'less_div10_client_unbillable_fringe', category: 'unbillable', col: 'AL' },
  { label: 'Less Div #10 Client Unbillable Overhead', key: 'less_div10_client_unbillable_overhead', category: 'unbillable', col: 'AM' },
  
  // Less Div #11 Unbillable (Columns AN-AP) - Company only
  { label: 'Less Div #11 Company Unbillable Labor', key: 'less_div11_company_unbillable_labor', category: 'unbillable', col: 'AN' },
  { label: 'Less Div #11 Company Unbillable Fringe', key: 'less_div11_company_unbillable_fringe', category: 'unbillable', col: 'AO' },
  { label: 'Less Div #11 Company Unbillable Overhead', key: 'less_div11_company_unbillable_overhead', category: 'unbillable', col: 'AP' },
  
  // Less No Division Unbillable (Columns AQ-AR)
  { label: 'Less No Division Unbillable Labor', key: 'less_no_division_unbillable_labor', category: 'unbillable', col: 'AQ' },
  { label: 'Less No Division Unbillable Fringe', key: 'less_no_division_unbillable_fringe', category: 'unbillable', col: 'AR' },
  
  // Less Other Unbillable (Columns AS-AW)
  { label: 'Less Unbillable ODCS', key: 'less_unbillable_odcs', category: 'unbillable', col: 'AS' },
  { label: 'Less Unbillable Subcontractors', key: 'less_unbillable_subcontractors', category: 'unbillable', col: 'AT' },
  { label: 'Less Unbillable SM&H', key: 'less_unbillable_smh', category: 'unbillable', col: 'AU' },
  { label: 'Less Unbillable G&A', key: 'less_unbillable_ga', category: 'unbillable', col: 'AV' },
  { label: 'Less Prior Year Unbillable Costs', key: 'less_prior_year_unbillable_costs', category: 'unbillable', col: 'AW' },
  
  // Contract Adjustments (Columns AX-BA)
  { label: 'Total Contract Limitations, Rebates/Credits - Rate Ceilings and Unburdened ODCs', key: 'total_contract_limitations', category: 'adjustment', col: 'AX' },
  { label: 'Net Cumulative Settled or Claimed Before Funding Limitation', key: 'net_cumulative_before_funding', category: 'adjustment', col: 'AY' },
  { label: 'Funding Limitation', key: 'funding_limitation', category: 'adjustment', col: 'AZ' },
  { label: 'Reduction for Amount Over Funding Limitation', key: 'reduction_over_funding', category: 'adjustment', col: 'BA' },
  
  // Net Claimed (Column BB)
  { label: 'Net Cumulative Settled or Claimed', key: 'net_cumulative_settled_or_claimed', category: 'total', col: 'BB' },
  
  // Billing Information (Columns BC-BF)
  { label: 'Voucher No.', key: 'voucher_no', category: 'billing', col: 'BC' },
  { label: 'Date Costs Billed Through', key: 'date_costs_billed_through', category: 'billing', col: 'BD' },
  { label: 'Cumulative Billed To Date Cost Amount', key: 'cumulative_billed_to_date', category: 'billing', col: 'BE' },
  { label: 'Cumulative Over (Under) Billing', key: 'cumulative_over_under_billing', category: 'grand_total', col: 'BF' },
  
  // Final Status (Column BG)
  { label: 'Physically Complete Y/N', key: 'physically_complete', category: 'info', col: 'BG' }
]);

const SCHEDULE_I_BASE_KEYS = new Set([
  'start_year',
  'internal_contract_number',
  'level_1_project_number',
  'prime_contract_number',
  'sub_contract_number',
  'contract_type',
  'prime_or_sub',
  'dod_or_non_dod',
  'settled_costs',
  'prior_year_unsettled_costs',
  'current_year_end_costs_claimed',
  'total_cumulative_settled_or_claimed',
  'less_no_division_unbillable_labor',
  'less_no_division_unbillable_fringe',
  'less_unbillable_odcs',
  'less_unbillable_subcontractors',
  'less_unbillable_ga',
  'less_prior_year_unbillable_costs',
  'total_contract_limitations',
  'net_cumulative_before_funding',
  'funding_limitation',
  'reduction_over_funding',
  'net_cumulative_settled_or_claimed',
  'voucher_no',
  'date_costs_billed_through',
  'cumulative_billed_to_date',
  'cumulative_over_under_billing',
  'physically_complete',
]);

const SCHEDULE_I_PAIR_GROUPS = {
  '02:company': ['less_div2_company_unbillable_labor', 'less_div2_company_unbillable_fringe', 'less_div2_company_unbillable_overhead'],
  '02:client': ['less_div2_client_unbillable_labor', 'less_div2_client_unbillable_fringe', 'less_div2_client_unbillable_overhead'],
  '04:company': ['less_div4_company_unbillable_labor', 'less_div4_company_unbillable_fringe', 'less_div4_company_unbillable_overhead'],
  '04:client': ['less_div4_client_unbillable_labor', 'less_div4_client_unbillable_fringe', 'less_div4_client_unbillable_overhead'],
  '06:company': ['less_div6_company_unbillable_labor', 'less_div6_company_unbillable_fringe', 'less_div6_company_unbillable_overhead'],
  '06:client': ['less_div6_client_unbillable_labor', 'less_div6_client_unbillable_fringe', 'less_div6_client_unbillable_overhead'],
  '08:company': ['less_div8_company_unbillable_labor', 'less_div8_company_unbillable_fringe', 'less_div8_company_unbillable_overhead'],
  '10:company': ['less_div10_company_unbillable_labor', 'less_div10_company_unbillable_fringe', 'less_div10_company_unbillable_overhead'],
  '10:client': ['less_div10_client_unbillable_labor', 'less_div10_client_unbillable_fringe', 'less_div10_client_unbillable_overhead'],
  '11:company': ['less_div11_company_unbillable_labor', 'less_div11_company_unbillable_fringe', 'less_div11_company_unbillable_overhead'],
};

const normalizeDivision = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.padStart(2, '0').slice(-2);
};

export const getScheduleIColumnsForLayout = (layout) => {
  if (!layout || !Array.isArray(layout.active_pairs) || layout.active_pairs.length === 0) {
    return SCHEDULE_I_COLUMNS;
  }

  const includeKeys = new Set(SCHEDULE_I_BASE_KEYS);
  for (const pair of layout.active_pairs) {
    const division = normalizeDivision(pair?.division);
    const site = String(pair?.site || '').toLowerCase();
    const pairKey = `${division}:${site}`;
    const keys = SCHEDULE_I_PAIR_GROUPS[pairKey] || [];
    for (const key of keys) includeKeys.add(key);
  }

  if (layout.include_material_handling) {
    includeKeys.add('less_unbillable_smh');
  }

  const filtered = SCHEDULE_I_COLUMNS.filter((column) => includeKeys.has(column.key));
  return filtered.length > 0 ? filtered : SCHEDULE_I_COLUMNS;
};

export default SCHEDULE_I_COLUMNS;
